export default __webpack_public_path__ + "static/media/Staff Icon.2a674bd3.svg";